const Provider = require("./Provider");
const NotificationsStore = require("stores/Notifications");

class Notifications extends Provider {

    constructor(props){
        super(props);

        this.store = new NotificationsStore();

    }

    /////////////////////////////////
    // Helpers
    /////////////////////////////////

    get providerProps() {
        return {
            notifications: this.store
        };
    }

}

module.exports = Notifications;